import { render, staticRenderFns } from "./indexDemand.vue?vue&type=template&id=66bd8585&"
import script from "./indexDemand.vue?vue&type=script&lang=js&"
export * from "./indexDemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports